module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image3_after_sale-2d7a719acf4f48bf8fc976e912882809.png";